import { getRanaApiV1 } from "@nens/rana/api-v1";

import { isTypedDescriptor } from "@/utils/is-descriptor-type";

import { CompleteFile } from "../../../types/file-reference-with-file";

export type UrlWithLabel = {
  url: string;
  label: string;
};

const _getUrlsForDescriptor = (descriptor: CompleteFile["file"]["descriptor"]): UrlWithLabel[] => {
  if (isTypedDescriptor(descriptor, "ogc_3d_tiles")) {
    return descriptor.meta.tilesets.map(({ timestep, id }) => {
      const base = `${window.location.origin}/v1/tenants/${getRanaApiV1().tenantId}`;
      const url = `${base}/file-descriptors/${descriptor.id}/3dtilesets/${id}/tileset.json`;
      return {
        url,
        label: timestep != null ? `${(timestep / 60).toFixed(0)} min` : "No timestep",
      };
    });
  }
  if (isTypedDescriptor(descriptor, "raster") || isTypedDescriptor(descriptor, "scenario")) {
    return [
      {
        url: descriptor.links.find(({ rel }) => rel === "wms")?.href ?? "",
        label: "WMS",
      },
    ];
  }

  return [];
};

// FUTURE. Remove this replacement when:
// 1. The API actually correctly returns v1 URLs instead of v1-alpha URLs.
// 2. The API returns https instead of http.
// This is a temporary fix to ensure that the URLs returned by this function actually work
export const getUrlsForDescriptor: typeof _getUrlsForDescriptor = (descriptor) => {
  return _getUrlsForDescriptor(descriptor).map(({ url, label }) => ({
    url: url.replace("/v1-alpha/", "/v1/").replace("http://", "https://"),
    label,
  }));
};
